export default __webpack_public_path__ + "static/media/Gloves of Rapturous Battle.b05d4ca8.jpg";